import {
  FETCH_COLOR_REQUEST,
  FETCH_COLOR_SUCCESS,
  FETCH_COLOR_FAILURE,
  ADD_COLOR_REQUEST,
  ADD_COLOR_SUCCESS,
  ADD_COLOR_FAILURE,
  UPDATE_COLOR_REQUEST,
  UPDATE_COLOR_SUCCESS,
  UPDATE_COLOR_FAILURE,
  DELETE_COLOR_REQUEST,
  DELETE_COLOR_SUCCESS,
  DELETE_COLOR_FAILURE,
  COLOR_FORM_ERROR,
  COLOR_FORM_SUCCESS,
  SET_COLOR_EDIT,
  CLEAR_COLOR_EDIT,
} from '../../../../types/masters/styles/color/colorTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingColor: null,
};

const colorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COLOR_REQUEST:
    case ADD_COLOR_REQUEST:
    case UPDATE_COLOR_REQUEST:
    case DELETE_COLOR_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_COLOR_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_COLOR_SUCCESS:
    case UPDATE_COLOR_SUCCESS:
    case DELETE_COLOR_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_COLOR_FAILURE:
    case ADD_COLOR_FAILURE:
    case UPDATE_COLOR_FAILURE:
    case DELETE_COLOR_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_COLOR_EDIT:
      return { ...state, editingColor: action.payload };
    case CLEAR_COLOR_EDIT:
      return { ...state, editingColor: null };
    default:
      return state;
  }
};

export default colorReducer; 